<template>
	<div>
		<v-row>

			<v-col
					class="order-last order-md-first"
					cols="12" :md="isDeclined ? 12 : 7"
					:lg="isDeclined ? 12 : 8"
			>
				<ui-box>
					<v-row>
						<v-col cols="12">
							<div class="pb-2">
								<h5>Pass Description</h5>
							</div>
							<div class="text-body-2" v-html="invite.description"></div>
						</v-col>
						<v-col class="mb-2 mb-md-0" cols="12">
							<merchant-pass-dates :invite="invite"></merchant-pass-dates>
						</v-col>
						<v-col class="mb-2 mb-md-0" cols="12">
							<merchant-project-engagement
									compact
									hideDeclines
									:invite="invite"
							></merchant-project-engagement>
						</v-col>
					</v-row>
				</ui-box>

				<ui-box>

					<v-sheet
							class="grey lighten-5 mb-4"
							:class="$vuetify.breakpoint.smAndDown ? 'pa-4' : 'pa-8'"
							rounded="lg"
					>
						<div class="align-center d-flex justify-space-between pb-2">
							<h5 class="mt-n2">Pass Organizer</h5>
						</div>

						<v-divider class="mb-4 opacity-50"></v-divider>

						<v-row>
							<v-col cols="auto">
								<v-avatar
										:key="`body-avatar-${invite.partner_id}`"
										class="active elevation-8 me-4"
										color="grey lighten-2"
										:size="$vuetify.breakpoint.smAndDown ? 44 : 64"
								>
									<img
											v-if="inviteHelpers.hasAvatarMedia(invite.partnerMedia, ['Icon196'])"
											:alt="invite.partnerName"
											:src="inviteHelpers.getAvatarMedia(invite.partnerMedia, ['Icon196'])"
									/>
									<span v-else>
										<v-icon color="grey darken-2" small>
											mdi-account-group-outline
										</v-icon>
									</span>
								</v-avatar>
							</v-col>
							<v-col>
								<v-row>
									<v-col cols="12" sm="6">
										<h6>{{ labels.campaignOrganizer }}</h6>
										<span class="text-caption text-md-body-2">
											{{ invite.partnerName }}
										</span>
									</v-col>
									<v-col cols="12" sm="6">
										<h6>{{ labels.dealPass }}</h6>
										<span class="text-caption text-md-body-2">
											{{ invite.name }}
										</span>
									</v-col>
								</v-row>
							</v-col>
						</v-row>
					</v-sheet>

					<merchant-pass-invitees :invite="invite"></merchant-pass-invitees>

				</ui-box>
				<div>
					<v-btn
							aria-label="Preview Invite"
							class="rounded-lg"
							color="secondary"
							depressed
							@click="e => showPreview = true"
					>
						Preview
					</v-btn>
				</div>
			</v-col>

			<v-col v-if="!isDeclined && invite.active" class="order-first order-md-last"
						 cols="12" md="5" lg="4">
				<!-- Required Items -->
				<ui-box
						:background-color="requirementsMet ? 'success' : 'error'"
						class="requirements white--text"
						noBorder
				>
					<v-row noGutters>
						<v-col cols="auto">
							<v-icon
									class="me-2 mt-1"
									color="white"
							> {{
									requirementsMet
											? 'mdi-check-circle-outline'
											: 'mdi-alert-circle-outline'
								}}
							</v-icon>
						</v-col>
						<v-col>
							<h6>Required Items</h6>
							<template v-if="showRequired">
								<p
										v-if="requirementsMet"
										class="mt-2 text-body-2 white--text"
								>
									Thank you. You are all set!
								</p>
								<p
										v-else
										class="mt-2 text-body-2 white--text"
								>
									The following unchecked items are required for your participation in
									this pass.
								</p>
							</template>
						</v-col>
						<v-col cols="auto">
							<v-btn dark icon small @click="toggleRequired">
								<v-icon v-if="showRequired">mdi-chevron-up</v-icon>
								<v-icon v-else>mdi-chevron-down</v-icon>
							</v-btn>
						</v-col>
					</v-row>

					<ui-box
							v-if="showRequired && (venuePendingActions.length || filteredRequiredProductTypes.length)"
							:background-color="`var(--v-${requirementsMet ? 'success' : 'error'}-darken1)`"
							class="mx-n4 mb-n4 requirements white--text"
							noBorder
					>
						<template
								v-if="venuePendingActions.length"
								v-for="(pending, idx) in venuePendingActions"
						>
							<v-row noGutters>
								<v-col cols="auto">
									<v-simple-checkbox
											dark
											disabled
											:value="false"
									></v-simple-checkbox>
									<div v-if="pending.subtitle" class="text-center">
										<v-icon class="mt-1" color="rgba(255,255,255,0.3)" small>
											mdi-arrow-right-bottom
										</v-icon>
									</div>
								</v-col>
								<v-col class="white--text">
									<span class="text-body-2">
										{{ pending.title }}
									</span>
									<div
											v-if="pending.subtitle"
											class="text-caption"
									>
										<v-divider class="my-1 opacity-40" dark></v-divider>
										{{ pending.subtitle }}
									</div>
								</v-col>
								<v-col class="ps-2" cols="auto">
									<v-btn
											color="white"
											depressed
											fab
											:href="pending.link"
											small
									>
										<v-icon color="success" small>mdi-arrow-right</v-icon>
									</v-btn>
								</v-col>
							</v-row>
							<v-divider
									v-if="idx < venuePendingActions.length - 1"
									class="my-2 opacity-70"
									dark
							></v-divider>
						</template>

						<v-divider
								v-if="venuePendingActions.length && filteredRequiredProductTypes.length"
								class="my-2 opacity-70"
								dark
						></v-divider>
						<template
								v-if="filteredRequiredProductTypes.length"
								v-for="(req, idx) in filteredRequiredProductTypes"
						>

							<!-- hide check-ins for now -->
							<v-row v-if="req.type !== 'check-in'" noGutters>
								<v-col cols="auto">
									<v-simple-checkbox
											v-model="req.fulfilled"
											dark
											disabled
											:indeterminate="req.submittedCount > 0 && req.submittedCount < req.min"
									></v-simple-checkbox>
									<div v-if="req.min > 1" class="text-center">
										<v-icon class="mt-1" color="rgba(255,255,255,0.3)" small>
											mdi-arrow-right-bottom
										</v-icon>
									</div>
								</v-col>
								<v-col class="white--text">
									<span class="text-body-2">
										Add {{ req.name }}{{ req.min > 1 ? ` (${req.min})` : null }}
									</span>
									<div
											v-if="req.min > 1"
											class="text-caption"
									>
										<v-divider class="my-1 opacity-40" dark></v-divider>
										{{
											`${Math.min(req.min, req.submittedCount)} of ${req.min} required`
										}}
										{{
											req.submittedCount > req.min
													? ` / ${req.submittedCount} submitted.`
													: null
										}}
									</div>
								</v-col>
								<v-col class="ps-2" cols="auto">
									<v-btn
											color="white"
											depressed
											:disabled="!canProgress"
											fab
											small
											@click="
												linkProductDialog = true;
												selectedProductType = req;
											"
									>
										<v-icon color="success" small>mdi-plus</v-icon>
									</v-btn>
								</v-col>


							</v-row>

							<!-- length - 2 because we've removed check-ins -->
							<v-divider
									v-if="idx < filteredRequiredProductTypes.length - 1"
									class="my-2 opacity-70"
									dark
							></v-divider>

						</template>

					</ui-box>

				</ui-box>

				<!-- Optional Items -->
				<ui-box
						v-if="invite.optionalProductTypes.length"
						:background-color="showOptional ? null : 'rgba(0, 0, 0, 0.03)'"
						class="requirements"
				>
					<v-row noGutters>
						<v-col cols="auto">
							<v-icon class="me-2 mt-1"> mdi-dots-horizontal-circle-outline</v-icon>
						</v-col>
						<v-col>
							<h6>Optional Items</h6>
							<p v-if="showOptional" class="mt-2 text-body-2">
								The following items are optional for your participation in this pass.
							</p>
						</v-col>
						<v-col cols="auto">
							<v-btn icon small @click="toggleOptional">
								<v-icon v-if="showOptional">mdi-chevron-up</v-icon>
								<v-icon v-else>mdi-chevron-down</v-icon>
							</v-btn>
						</v-col>
					</v-row>

					<ui-box
							v-if="showOptional"
							background-color="rgba(0, 0, 0, 0.02)"
							class="mx-n4 mb-n4 requirements"
					>
						<template
								v-if="invite.optionalProductTypes.length"
								v-for="(opt, idx) in invite.optionalProductTypes"
						>

							<!-- hide check-ins for now -->
							<v-row noGutters>
								<v-col cols="auto">
									<div style="height: 25px; width: 32px;">
										<v-icon>
											mdi-checkbox-blank-circle-outline
										</v-icon>
									</div>
								</v-col>
								<v-col>
									<span class="text-body-2">
										Add {{ opt.name }}
									</span>
								</v-col>
								<v-col class="ps-2" cols="auto">
									<v-btn
											color="success"
											depressed
											:disabled="!canProgress"
											fab
											outlined
											small
											@click="
												linkProductDialog = true;
												selectedProductType = opt;
											"
									>
										<v-icon color="success" small>mdi-plus</v-icon>
									</v-btn>
								</v-col>


							</v-row>

							<!-- length - 2 because we've removed check-ins -->
							<v-divider
									v-if="idx < invite.optionalProductTypes.length - 1"
									class="my-2 opacity-70"
							></v-divider>

						</template>

					</ui-box>

				</ui-box>

				<v-divider
						v-if="$vuetify.breakpoint.smAndDown"
						class="mb-4 mt-8 mx-4"
				></v-divider>

			</v-col>
		</v-row>

		<v-dialog
				v-model="linkProductDialog"
				content-class="rounded-xl"
				persistent
				scrollable
				width="800px"
		>
			<v-card class="position-relative" rounded="xl">
				<v-card-title class="d-flex justify-space-between ma-0 ma-md-4">
					<div class="w-100">
						<div class="align-center d-flex justify-space-between">
							<h6>Link Existing Products</h6>
							<v-btn
									class="mt-n1 me-n2"
									color="black"
									depressed
									icon
									@click="
										linkProductDialog = false;
										selectedMatchedProducts = [];
										selectedProductType = undefined;
									"
							>
								<v-icon>mdi-close</v-icon>
							</v-btn>
						</div>
					</div>
				</v-card-title>
				<v-card-text
						v-if="selectedProductType"
						class="pa-4 pa-md-8 text-body-2"
				>

					<div v-if="selectedProductType.product_instructions?.length">
						<v-row>
							<v-col class="text-body-2">
								{{ selectedProductType.product_instructions }}
							</v-col>
						</v-row>

						<v-divider class="mb-4 mt-8 opacity-70"></v-divider>
					</div>

					<v-row>
						<v-col>
							<v-list
									v-if="selectedProductType && selectedProductType.matchingProducts.length"
							>
								<v-list-item-group
										v-model="selectedMatchedProducts"
										multiple
								>
									<template
											v-for="(product, idx) in selectedProductType.matchingProducts"
									>
										<v-list-item
												v-if="!alreadySubmitted(product.id)"
												:key="`item-${idx}`"
												active-class="primary--text text--accent-4"
												class="my-1"
												:value="product.id"
										>
											<template v-slot:default="{ active }">
												<v-list-item-content>
													<v-list-item-title v-text="product.name"></v-list-item-title>
												</v-list-item-content>

												<v-list-item-action>
													<v-checkbox :input-value="active"></v-checkbox>
												</v-list-item-action>
											</template>
										</v-list-item>
									</template>
								</v-list-item-group>
							</v-list>
							<span v-else class="d-flex justify-center text-body-2 w-100">No existing product is a match for this requirement.</span>
						</v-col>
					</v-row>
				</v-card-text>

				<v-card-actions>
					<div class="w-100">
						<div
								v-if="selectedProductType && selectedProductType.matchingProducts.length"
								class="align-center d-flex justify-space-between"
						>
							<div>
								<v-btn
										class="me-2 me-md-4 rounded-lg"
										color="primary"
										depressed
										:large="$vuetify.breakpoint.mdAndUp"
										text
										@click="createNewProduct()"
								>
									<v-icon class="me-1 ms-n1" small>mdi-plus</v-icon>
									Create New
								</v-btn>
							</div>
							<span></span>
							<div class="d-flex justify-end">
								<v-btn
										class="me-2 me-md-4 rounded-lg"
										color="grey darken-1"
										depressed
										:large="$vuetify.breakpoint.mdAndUp"
										outlined
										@click="
											() => {
												linkProductDialog = false;
											}
										"
								>
									Cancel
								</v-btn>
								<v-btn
										class="rounded-lg"
										color="primary"
										depressed
										:large="$vuetify.breakpoint.mdAndUp"
										@click="addProducts"
								>
									Submit
								</v-btn>
							</div>
						</div>

						<div v-else class="align-center d-flex justify-space-between">
							<span></span>
							<div>
								<v-btn
										class="me-2 me-md-4 rounded-lg"
										color="grey darken-1"
										depressed
										:large="$vuetify.breakpoint.mdAndUp"
										outlined
										@click="
											() => {
												linkProductDialog = false;
											}
										"
								>
									Cancel
								</v-btn>
								<v-btn
										class="rounded-lg"
										color="primary"
										depressed
										:large="$vuetify.breakpoint.mdAndUp"
										@click="createNewProduct()"
								>
									Create New
								</v-btn>
							</div>
						</div>
					</div>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<mobile-pass-preview-modal
				v-if="showPreview"
				continue-text="Close"
				:preview-url="previewUrl"
				submit-text=""
				@reject-preview="e => showPreview = false"
		></mobile-pass-preview-modal>

	</div>
</template>

<script>
import { inviteHelpers } from '../../../Shared/helpers';

export default {
	name: 'CampaignInvite',
	props: {
		acceptedTemplates: {
			type: Array,
			default: () => []
		},
		invite: {
			type: Object,
			default: () => ({})
		},
		linkedProducts: {
			type: Array,
			default: () => []
		},
		previewUrl: {
			type: String,
			default: null
		},
		productReqs: {
			type: Array,
			default: () => []
		},
		statuses: {
			type: Array,
			default: () => []
		},
		venue: {
			type: Object,
			default: () => ({})
		},
		venuePendingActions: {
			type: Array,
			default: () => []
		}
	},
	data() {
		return {
			fulfilledProducts: [],
			inviteHelpers,
			linkProductDialog: false,
			panels: {
				active: null,
				declined: null,
				inProgress: null,
				invited: 0, // always show the first invite is there are any
				review: null
			},
			showPreview: null,
			progressOpen: false,
			selectedMatchedProducts: [],
			selectedProductType: undefined,
			showOptional: true,
			showRequired: true
		};
	},
	computed: {
		canProgress() {
			return !['invited', 'declined', 'active'].includes(this.invite.statusCode);
		},
		filteredRequiredProductTypes() {
			return this.invite.requiredProductTypes.filter(req => req.type !== 'check-in');
		},
		isDeclined() {
			return this.invite.statusName === 'Decline';
		},
		labels() {
			const isMdAndDown = this.$vuetify.breakpoint.mdAndDown;
			return {
				dealPass: isMdAndDown ? 'Pass' : 'Pass Name',
				campaignOrganizer: isMdAndDown ? 'Organizer' : 'Organizer'
			};
		},
		optionalSubmittedCount() {
			return this.invite.optionalProductTypes.reduce((
					acc,
					p
			) => acc + p.submittedCount, 0);
		},
		requirementsMet() {
			return !this.venuePendingActions.length
					&& !this.filteredRequiredProductTypes.some(t => !t.fulfilled);
		},
		statusDescription() {
			return 'Status Description Here';
		},
		statusTitle() {
			return 'Status Title Here';
		}
	},
	created() {
		this.showOptional = this.$vuetify.breakpoint.mdAndUp;
		this.showRequired = this.$vuetify.breakpoint.mdAndUp;
	},
	methods: {
		alreadySubmitted(productId) {
			return this.invite.productsSubmitted.some(sub => sub.id === productId);
		},
		createNewProduct() {
			this.linkProductDialog = false;
			let url = `/merchant-portal/${this.venue.id}/products/main/create-product?templateId=${this.selectedProductType.product_template}&inviteId=${this.invite.id}`;

			if(this.selectedProductType.limit_child_templates) {
				for (let ctId of this.selectedProductType.child_templates)
					url += '&childTemplateIds[]=' + ctId;
			}

			window.location.href = url;
		},
		addProducts() {
			this.axios.put(`/merchant-portal/${this.venue.id}/invites/view/add-products/${this.invite.id}`, { productIds: this.selectedMatchedProducts }).then((resp) => {
				this.$emit('invite-updated', resp.data);
			});

			this.linkProductDialog = false;
		},
		toggleOptional() {
			this.showOptional = !this.showOptional;
		},
		toggleRequired() {
			this.showRequired = !this.showRequired;
		}
	}
};
</script>

<style lang="scss" scoped>
@use 'sass:color';
@import '~vuetify/src/styles/styles.sass';
@import '~vuetify/src/styles/settings/_variables';

.requirements {

	& .v-simple-checkbox .theme--dark.v-icon.v-icon.v-icon--disabled {
		color: white !important;
	}

}


.progress {
	background-color: white;
	border: solid 1px #e5e5e5 !important;
	border-radius: 1rem;
	padding: 0.5rem 0 0.5rem 1.5rem !important;
	position: relative;

	&:not(.progress--closed) {
		border: none !important;
		padding: 0 0 0 3rem !important;
	}

	&:not(.progress--closed)::before {
		animation: border-anim 1s infinite linear;
		background-image: linear-gradient(90deg, rgba(0, 0, 0, 0.08) 50%, transparent 50%),
		linear-gradient(90deg, rgba(0, 0, 0, 0.08) 50%, transparent 50%),
		linear-gradient(0deg, rgba(0, 0, 0, 0.08) 50%, transparent 50%),
		linear-gradient(0deg, rgba(0, 0, 0, 0.08) 50%, transparent 50%);
		background-repeat: repeat-x, repeat-x, repeat-y, repeat-y;
		background-size: 15px 2px, 15px 2px, 2px 15px, 0 15px;
		background-position: left top, right bottom, left bottom, right top;

		border-bottom-left-radius: map-get($rounded, 'lg');
		border-top-left-radius: map-get($rounded, 'lg');
		content: '';
		position: absolute;
		left: 1rem;
		top: 1.875rem;
		bottom: 2rem;
		width: 2.5rem;
		z-index: 1;

		@keyframes border-anim {
			0% {
				background-position: left top, right bottom, left bottom, right top;
			}
			100% {
				background-position: left -15px top, right -15px bottom, left bottom -15px, right top -15px;
			}
		}

		@media #{map-get($display-breakpoints, 'sm-and-down')} {
			top: 1.5rem;
			bottom: 1.5rem;
		}
	}

	&.complete::before {
		background-image: none;
		border: solid 2px rgba(76, 175, 80, 0.2);
		border-right: none;
		border-bottom-left-radius: map-get($rounded, 'xl');
		border-top-left-radius: map-get($rounded, 'xl');
	}

	&::after {
		background: white;
		border-bottom-left-radius: 21px;
		border-top-left-radius: 21px;
		content: '';
		display: none;
		position: absolute;
		left: 1.125rem;
		top: 2rem;
		bottom: 2.125rem;
		width: 2.375rem;
		z-index: 2;

		@media #{map-get($display-breakpoints, 'sm-and-down')} {
			top: 1.625rem;
			bottom: 1.625rem;
		}
	}

	& > .row {
		position: relative;

		& > .progress__icon {
			background: white;
			border-radius: 50%;
			height: 32px;
			left: -31px;
			padding: 0.25rem;
			position: absolute;
			top: 2rem;
			width: 32px;
			z-index: 3;

			@media #{map-get($display-breakpoints, 'sm-and-down')} {
				left: -39px;
				top: 1.5rem;
			}
		}
	}

	& > .row:first-child {
		position: relative;

		& > .progress__icon {
			top: 1rem;

			@media #{map-get($display-breakpoints, 'sm-and-down')} {
				left: -12px;
				top: 0.5rem;
			}
		}

		& > .col {
			min-height: 48px;
		}
	}
}

.to-do {
	&__item {
		align-items: center !important;
		background-color: rgba(0, 0, 0, 0.02);
		border-radius: map-get($rounded, 'lg');
		display: flex;
		justify-content: space-between !important;
		margin-top: 0.25rem;
		min-height: 2.75rem;
		padding: 0.5rem;
		transition: background-color 0.3s ease-in-out;

		&:not(.completed):hover {
			background-color: saturate(mix(white, #7a9176, 91%), 30%);
			padding: 0.5rem;
		}

		&.completed {
			background-color: saturate(mix(white, #7a9176, 85%), 30%);
		}
	}
}
</style>